import { SerializedStyles } from '@emotion/serialize'
import { Grid, Text } from 'bold-ui'
import { FilterItem } from 'components/filteritem'
import React from 'react'

interface FilterTagsProps {
  tags: FilterTag[]
}

export type FilterTag = [string, string, SerializedStyles?]

export const FilterTags = (props: FilterTagsProps) => {
  const { tags } = props

  return tags.some(isTagTruthy) ? (
    <Grid alignItems='center' justifyContent='flex-start' gap={0.25} gapVertical={0.25} wrap>
      {tags.map(
        ([label, text, style]) => text && <FilterItem key={label} label={`${label}:`} value={text} style={style} />
      )}
    </Grid>
  ) : (
    <Text>Sem filtros ativos</Text>
  )
}

const isTagTruthy = ([_, text]: FilterTag) => !!text
